module.exports = __webpack_public_path__ + "static/Packages-106ccf7c579a8fa1bb69fb3a83fa3f81.png";